import { forwardRef, ImgHTMLAttributes } from 'react';

import logoSrc from './logo.svg';

const Logo = forwardRef<HTMLImageElement, Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'>>((props, ref) => (
  <img src={logoSrc} alt="Patient FI" width={160} {...props} ref={ref} />
));

export default Logo;
